import { AssignActionPlugin } from './AssignAction';
export const defaultActionPlugins = [AssignActionPlugin];
//# sourceMappingURL=default.js.map